export default __webpack_public_path__ + "static/media/collaboration.67be2a84.svg";